// extracted by mini-css-extract-plugin
export var text = "_bu-0";